import DefaultNavbar from 'components/DefaultNavbar';
import DefaultFooter from 'components/DefaultFooter';
import ContactSection from 'components/landing/ContactSection';

export default function Contact() {
    return (
        <>
            <DefaultNavbar />
            <main style={{ backgroundColor: '#304c79' }}>
                <ContactSection />
            </main>
            <DefaultFooter />
        </>
    );
}
